import * as Icons from "lucide-react";
import { Timer } from "lucide-react";
import { useCountdown } from "@/lib/format";

export const CategoryIcon = ({ name, className = "w-6 h-6" }) => {
  const I = Icons[name] || Icons.Tag;
  return <I className={className} />;
};

export const Countdown = ({ to, className = "", testid = "countdown" }) => {
  const { text, done } = useCountdown(to);
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 font-mono font-bold text-xs tracking-wider px-2 py-1 rounded ${done ? "bg-slate-200 text-slate-500" : "bg-slate-900 text-amber-400"} ${className}`}>
      <Timer className="w-3.5 h-3.5" /> {text}
    </span>
  );
};

const STATUS_STYLES = {
  active: "bg-emerald-100 text-emerald-800", approved: "bg-emerald-100 text-emerald-800", redeemed: "bg-indigo-100 text-indigo-800",
  pending: "bg-amber-100 text-amber-800", pending_review: "bg-amber-100 text-amber-800", open: "bg-amber-100 text-amber-800",
  paused: "bg-sky-100 text-sky-800", draft: "bg-slate-100 text-slate-700", expired: "bg-slate-200 text-slate-600",
  archived: "bg-slate-200 text-slate-600", suspended: "bg-red-100 text-red-700", rejected: "bg-red-100 text-red-700",
  cancelled: "bg-red-100 text-red-700", replaced: "bg-slate-200 text-slate-600", paid_offline: "bg-emerald-100 text-emerald-800",
  complimentary: "bg-violet-100 text-violet-800", waived: "bg-violet-100 text-violet-800", fulfilled: "bg-emerald-100 text-emerald-800",
};

export const StatusBadge = ({ status, testid }) => (
  <span data-testid={testid} className={`inline-flex px-2 py-0.5 rounded-full text-[11px] font-bold uppercase tracking-wide ${STATUS_STYLES[status] || "bg-slate-100 text-slate-700"}`}>
    {String(status || "").replace(/_/g, " ")}
  </span>
);

export const Kpi = ({ label, value, icon: I, accent = "text-red-500", testid }) => (
  <div data-testid={testid} className="bg-white border border-slate-200 rounded-2xl p-4 flex flex-col gap-2">
    <div className="flex items-center justify-between text-xs font-semibold uppercase tracking-wider text-slate-500">
      {label} {I && <I className={`w-4 h-4 ${accent}`} />}
    </div>
    <div className="font-heading text-2xl font-extrabold text-slate-900">{value}</div>
  </div>
);

export const Empty = ({ title, children, testid }) => (
  <div data-testid={testid} className="border-2 border-dashed border-slate-200 rounded-2xl p-10 text-center text-slate-500">
    <p className="font-semibold text-slate-700">{title}</p>
    {children}
  </div>
);

export const Field = ({ label, children, hint }) => (
  <label className="block space-y-1.5">
    <span className="text-sm font-semibold text-slate-700">{label}</span>
    {children}
    {hint && <span className="block text-xs text-slate-500">{hint}</span>}
  </label>
);

export const NativeSelect = ({ className = "", ...p }) => (
  <select {...p} className={`w-full h-10 rounded-md border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-red-400 ${className}`} />
);
